export const IS_SHOW_REPLY_ENTER_TOUR_LOCALSTORAGE_KEY = 'is-show-enter-reply-tour';
export const IS_SEND_ENTER_VARIANT_LOCALSTORAGE_KEY = 'is-send-enter-variant';
